
(function() {


  // Sort button for mobile
  document.addEventListener("DOMContentLoaded", () => {
    function removeClonedModal() {
      document.querySelectorAll('.modal.cloned-facets, .modal-overlay').forEach(el => {
        el.classList.remove('modal--active');
        setTimeout(() => el.remove(), 300); // wait for animation to finish
      });
    }

    function cloneFacetsToModal() {
      if (window.innerWidth > 1023) return;

      const container = document.querySelector('.facets-mobile-wrapper');
      if (!container) return;

      removeClonedModal();

      const overlay = document.createElement('div');
      overlay.classList.add('modal-overlay');
      overlay.addEventListener('click', removeClonedModal);
      document.body.appendChild(overlay);

      const modalWrapper = document.createElement('div');
      modalWrapper.classList.add('modal', 'cloned-facets');

      const closeButton = document.createElement('div');
      closeButton.classList.add('modal-close');
      closeButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M12.5 3.5L3.5 12.5" stroke="black" stroke-linecap="square" stroke-linejoin="round"/>
          <path d="M12.5 12.5L3.5 3.5" stroke="black" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>
      `;
      closeButton.addEventListener('click', removeClonedModal);
      modalWrapper.appendChild(closeButton);

      const contentWrapper = document.createElement('div');
      contentWrapper.innerHTML = container.innerHTML;
      contentWrapper.querySelectorAll('details').forEach(detail => detail.setAttribute('open', ''));

      modalWrapper.appendChild(contentWrapper);
      document.body.appendChild(modalWrapper);

      setTimeout(() => {
        overlay.classList.add('modal--active');
        modalWrapper.classList.add('modal--active');
      }, 10);
    }
    document.addEventListener('click', (e) => {
      const panel = e.target.closest('.facets--horizontal .facets__panel');
      if (panel) {
        setTimeout(() => {
          if (window.innerWidth > 1023) return;
          panel.hasAttribute('open') ? cloneFacetsToModal() : removeClonedModal();
        }, 0);
      }
    });

    document.addEventListener('click', (e) => {
      const option = e.target.closest('.sorting-filter__option');
      if (option && window.innerWidth <= 1023) {
        // Optional: Wait for filter change logic to finish before closing
        setTimeout(() => removeClonedModal(), 300);
      }
    });
  });

  // mutation observer for View zoom-out grid > auto focus on last image collection grid
  function scrollGalleryToSlide(gallery, index) {
    const slideshow = gallery.querySelector('slideshow-slides');
    const slides = gallery.querySelectorAll('slideshow-slide');
    if (!slideshow || slides.length <= 1) return;

    const targetSlide = slides[index];
    if (!targetSlide) return;

    requestAnimationFrame(() => {
      slideshow.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'auto' // no animation
      });
    });
  }

  function handleGalleryScroll(ul) {
    const isZoomOut = ul.getAttribute('product-grid-view') === 'zoom-out';

    // Only scroll galleries for zoom-out (to show last slide)
    // For other layouts, galleries already show first slide - no action needed
    if (!isZoomOut) return;

    const galleries = ul.querySelectorAll('.card-gallery');

    // Defer to next frame to avoid layout thrashing during transition
    requestAnimationFrame(() => {
      galleries.forEach((gallery) => {
        const slides = gallery.querySelectorAll('slideshow-slide');
        if (slides.length > 1) {
          scrollGalleryToSlide(gallery, slides.length - 1);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const uls = document.querySelectorAll('ul[product-grid-view]');

    uls.forEach((ul) => handleGalleryScroll(ul));

    const attributeObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'product-grid-view' &&
          mutation.target.matches('ul[product-grid-view]')
        ) {
          handleGalleryScroll(mutation.target);
        }
      });
    });

    const contentObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          // Case 1: A new product card is injected
          if (node.matches('.product-grid__item') || node.querySelector('.product-grid__item')) {
            const ul = node.closest('ul[product-grid-view]');
            if (ul) handleGalleryScroll(ul);
          }

          // Case 2: A card-gallery was added directly
          if (node.matches('.card-gallery') || node.querySelector('.card-gallery')) {
            const ul = node.closest('ul[product-grid-view]');
            if (ul) handleGalleryScroll(ul);
          }
        });
      });
    });

    uls.forEach((ul) => {
      attributeObserver.observe(ul, {
        attributes: true,
        attributeFilter: ['product-grid-view'],
      });

      contentObserver.observe(ul, {
        childList: true,
        subtree: true
      });
    });
  });

function updateStickyVars() {
        const header = document.getElementById('header-component');
        const facets = document.querySelector('.facets--horizontal facets-form-component');

        if (header) {
            const headerHeight = header.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        }

        if (facets) {
            const facetsHeight = facets.offsetHeight;
            document.documentElement.style.setProperty('--facets-height', `${facetsHeight}px`);
        }
        }

        // Update heights on resize
        window.addEventListener('resize', updateStickyVars);

        // Toggle .scrolled class on scroll
        window.addEventListener('scroll', () => {
        document.body.classList.toggle('scrolled', window.scrollY > 66);
});
document.addEventListener('DOMContentLoaded', updateStickyVars);


  // filter drawer - using event delegation to survive DOM re-renders
  document.addEventListener('DOMContentLoaded', function () {
    // close drawer function
    function closeDrawer(e) {
      const drawer = document.getElementById('custom-filter');
      if (!drawer) return;

      if (e) e.preventDefault(); // prevent default if <a>
      drawer.classList.remove('active');

      // delay removal of no-scroll
      setTimeout(() => {
        document.body.classList.remove('no-scroll');
      }, 300); // adjust delay (ms) to match your CSS transition
    }

    // open drawer function
    function openDrawer(e) {
      const drawer = document.getElementById('custom-filter');
      if (!drawer) return;

      drawer.classList.add('active');
      document.body.classList.add('no-scroll');
    }

    // Use event delegation on document body (survives DOM re-renders)
    document.body.addEventListener('click', function(e) {
      // Open drawer
      if (e.target.closest('.custom-filter')) {
        console.log('Opening filter drawer');
        openDrawer(e);
        return;
      }

      // Close drawer via close button or apply button
      if (e.target.closest('.custom-filter-close, .apply-btn')) {
        console.log('Closing via button:', e.target);
        closeDrawer(e);
        return;
      }

      // Close drawer via overlay
      if (e.target.id === 'CustomFilterOverlay' || e.target.classList.contains('custom-filter-drawer__overlay')) {
        console.log('Closing via overlay:', e.target);
        closeDrawer(e);
        return;
      }
    });

    // Close drawer with Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const drawer = document.getElementById('custom-filter');
        if (drawer && drawer.classList.contains('active')) {
          console.log('Closing via Escape key');
          closeDrawer(e);
        }
      }
    });
  });

  // Hide filter button when footer is in view
  document.addEventListener('DOMContentLoaded', function () {
    const filterButton = document.querySelector('.custom-filter-wrapper-mobile');
    const footer = document.querySelector('footer');
    
    if (!filterButton || !footer) return;
    
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          filterButton.classList.add('hide-on-footer');
        } else {
          filterButton.classList.remove('hide-on-footer');
        }
      });
    }, observerOptions);
    
    observer.observe(footer);
  });

/*
// siblings / colour swatches
async function renderColorSiblings(context = document) {
  const containers = context.querySelectorAll('.color-siblings[data-color-sibling-handles]');

  for (const container of containers) {
    const grid = container.querySelector('.color-sibling-grid');
    if (!grid) continue;

    // Clear grid before repopulating (prevents duplicates)
    grid.innerHTML = '';

    const handles = container.dataset.colorSiblingHandles
      .split(',')
      .map(h => h.trim())
      .filter(Boolean);

    for (const handle of handles) {
      // Scope to the nearest product-card
      const productCard = container.closest('.product-card') ||
        document.querySelector(`.product-card[data-product-handle="${handle}"]`);

      // Try to find JSON data from existing scripts
      let productData = null;
      const scripts = document.querySelectorAll('script[id^="ProductData-"]');
      for (const script of scripts) {
        try {
          const data = JSON.parse(script.textContent);
          if (data.handle === handle) {
            productData = data;
            break;
          }
        } catch (e) {
          continue;
        }
      }

      // If still no data, fetch via Shopify's product JSON endpoint
      if (!productData) {
        try {
          const res = await fetch(`/products/${handle}.js`);
          if (res.ok) {
            productData = await res.json();
          }
        } catch (e) {
          console.warn(`Failed to load product data for ${handle}`, e);
          continue;
        }
      }

      if (!productData) continue;

      // Build swatch
      const colorName = productData?.options?.[0]?.values?.[0] || 'Color';
      const colorSwatch = productData?.metafields?.['related.color'];
      const fallbackClassName = colorName
        ?.trim()
        ?.toLowerCase()
        ?.replace(/\s+/g, '-');

      const a = document.createElement('a');
      a.href = `/products/${handle}`;
      a.className = 'color-sibling-item';
      if (window.location.pathname.includes(handle)) {
        a.classList.add('active');
      }
      a.title = `${productData?.title || ''} ${colorName}`;

      const swatch = document.createElement('div');
      swatch.className = `sibling-swatch${fallbackClassName ? ` color-siblings-${fallbackClassName}` : ''}`;
      if (colorSwatch) {
        swatch.style.backgroundColor = colorSwatch;
      }

      const hiddenText = document.createElement('span');
      hiddenText.className = 'sibling-color-name is-visually-hidden';
      hiddenText.textContent = colorName;

      a.appendChild(swatch);
      a.appendChild(hiddenText);
      grid.appendChild(a);
    }
  }
}


  document.addEventListener('DOMContentLoaded', () => {
    renderColorSiblings();
  });

  // Fallback for infinite scroll / AJAX frameworks (e.g., ajaxinate)
  document.addEventListener('ajaxinate:loaded', () => {
    renderColorSiblings();
  });

  document.addEventListener('predictive-search:render', () => {
    requestAnimationFrame(() => {
      renderColorSiblings();
    });
  });

// MutationObserver fallback for dynamically injected products
const observer = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if ([...mutation.addedNodes].some(n => n.nodeType === 1 && n.matches?.('.product-card, .color-siblings'))) {
      requestAnimationFrame(() => renderColorSiblings());
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
*/

/* -------------------- Color Siblings with IntersectionObserver --------------------
 * DISABLED: Using server-side rendered siblings instead to avoid AJAX requests
 * Siblings are rendered in product-main-siblings.liquid via Liquid
 *
 * To re-enable: uncomment this entire block
 *

let siblingsQueue = [];
let isProcessingQueue = false;
const SIBLINGS_BATCH_SIZE = 6;

function shouldLoadSiblings() {
  const isMobile = window.innerWidth < 750;
  if (isMobile) {
    console.log('[Siblings] Disabled on mobile for memory testing');
    return false;
  }
  return true;
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function fetchSiblingsForCard(card) {
  return new Promise((resolve) => {
    const handle = card.getAttribute("data-product-handle");
    if (!handle) {
      resolve();
      return;
    }

    fetch(`/products/${handle}?view=siblings`)
      .then(res => res.text())
      .then(html => {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        const siblings = temp.querySelector(".pdp-siblings");
        if (siblings) {
          const target = card.querySelector(".color-siblings.pdp-siblings");
          if (target) {
            target.innerHTML = "";
            target.appendChild(siblings.cloneNode(true));
          }
        }
        resolve();
      })
      .catch(err => {
        console.error("Error fetching product siblings:", err);
        resolve();
      });
  });
}

async function processSiblingsQueue() {
  if (isProcessingQueue || siblingsQueue.length === 0) return;
  if (!shouldLoadSiblings()) {
    siblingsQueue = [];
    return;
  }
  isProcessingQueue = true;
  while (siblingsQueue.length > 0) {
    const batch = siblingsQueue.splice(0, SIBLINGS_BATCH_SIZE);
    await Promise.all(batch.map(card => fetchSiblingsForCard(card)));
    if (siblingsQueue.length > 0) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
  }
  isProcessingQueue = false;
}

const siblingsObserver = new IntersectionObserver((entries) => {
  if (!shouldLoadSiblings()) return;
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const card = entry.target;
      card.setAttribute("data-siblings-observed", "true");
      siblingsObserver.unobserve(card);
      siblingsQueue.push(card);
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => processSiblingsQueue());
      } else {
        setTimeout(() => processSiblingsQueue(), 100);
      }
    }
  });
}, {
  rootMargin: '100px',
  threshold: 0
});

document.addEventListener('results-list/updateLayout', (event) => {
  const layout = event.detail?.layout;
  const isMobile = window.innerWidth < 750;
  if (isMobile && layout === 'zoom-in') {
    siblingsQueue = [];
  }
});

function observeCardsForSiblings(context = document) {
  const cards = context.querySelectorAll('.product-card:not([data-siblings-observed])');
  cards.forEach(card => {
    siblingsObserver.observe(card);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  observeCardsForSiblings();
});

document.addEventListener("ajaxinate:loaded", () => {
  requestIdleCallback ? requestIdleCallback(() => observeCardsForSiblings()) : setTimeout(() => observeCardsForSiblings(), 100);
});

document.addEventListener("predictive-search:render", () => {
  requestIdleCallback ? requestIdleCallback(() => observeCardsForSiblings()) : setTimeout(() => observeCardsForSiblings(), 100);
});

const debouncedObserveCards = debounce(() => {
  requestIdleCallback ? requestIdleCallback(() => observeCardsForSiblings()) : setTimeout(() => observeCardsForSiblings(), 100);
}, 300);

const siblingsContentObserver = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if ([...mutation.addedNodes].some(n =>
      n.nodeType === 1 &&
      (n.matches?.(".product-card") || n.querySelector?.(".product-card"))
    )) {
      debouncedObserveCards();
      break;
    }
  }
});
siblingsContentObserver.observe(document.body, { childList: true, subtree: true });

*/

/*** Variant SOrt */
function sortSizeGrid(grid) {
  const predefinedOrder = ['XXS', 'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'XL', 'XXL', 'XXXL'];
  const labels = Array.from(grid.querySelectorAll('.size-box'));
 

  function getSize(label) {
    return label.dataset.size ? label.dataset.size.trim() : label.textContent.trim();
  }

  function getSizeRank(size) {
    // Remove dollar sign and commas for numeric comparison
    const numericString = size.replace(/[^0-9]/g, '');
    const num = parseInt(numericString, 10);

    // Predefined sizes like XS, S, M...
    const index = predefinedOrder.indexOf(size);
    if (index !== -1) return { rank: 0, value: index };

    // Dollar or numeric sizes
    if (!isNaN(num)) return { rank: 1, value: num };

    // Single-letter alphabetical sizes
    if (/^[a-zA-Z]$/.test(size)) return { rank: 2, value: size.toUpperCase().charCodeAt(0) };

    // Fallback for unhandled values
    return { rank: 3, value: size };
  }

  labels.sort((a, b) => {
    const aSize = getSize(a);
    const bSize = getSize(b);

    const aRank = getSizeRank(aSize);
    const bRank = getSizeRank(bSize);

    if (aRank.rank !== bRank.rank) {
      return aRank.rank - bRank.rank;
    } else {
      return aRank.value - bRank.value;
    }
  });

  // Disconnect observer to prevent mutation loop if present
  if (grid._observer) grid._observer.disconnect();

  // Re-append in sorted order
  labels.forEach(label => grid.appendChild(label));

  // Reconnect observer
  if (grid._observer) grid._observer.observe(grid, { childList: true, subtree: true });
}



document.addEventListener('DOMContentLoaded', () => {
  // Sort & observe existing size grids
  const grids = document.querySelectorAll('.size-grid');
  grids.forEach(grid => {
    sortSizeGrid(grid);

    const observer = new MutationObserver(() => {
      sortSizeGrid(grid);
    });

    observer.observe(grid, { childList: true, subtree: true });
    grid._observer = observer;
  });

  // Now observe the collection grid container for injected .product-grid__item elements
  const collectionGrid = document.querySelector('.product-grid'); // Adjust selector if needed
  if (!collectionGrid) return;

  const collectionObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            // Check if added node is a .product-grid__item or contains them
            if (node.classList.contains('product-grid__item')) {
              // Find any size-grid inside this new item and sort it
              node.querySelectorAll('.size-grid').forEach(sortSizeGrid);
            } else {
              // If node is a wrapper/container, check inside for multiple .product-grid__item elements
              node.querySelectorAll('.product-grid__item').forEach(item => {
                item.querySelectorAll('.size-grid').forEach(sortSizeGrid);
              });
            }
          }
        });
      }
    });
  });

  collectionObserver.observe(collectionGrid, {
    childList: true,
    subtree: true // subtree true to catch deep additions
  });
});

// recommendatation sort
document.addEventListener('DOMContentLoaded', () => {
  const recommendations = document.querySelector('.product-recommendations'); // adjust selector if needed

  if (!recommendations) return;

  function sortSizeGrid(grid) {
    const predefinedOrder = ['XXS', 'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'XL', 'XXL', 'XXXL'];
    const labels = Array.from(grid.querySelectorAll('.size-box'));

    function getSize(label) {
      return label.dataset.size ? label.dataset.size.trim() : label.textContent.trim();
    }

    function getSizeRank(size) {
      const index = predefinedOrder.indexOf(size);
      if (index !== -1) return { rank: 0, value: index };

      const num = parseInt(size, 10);
      if (!isNaN(num)) return { rank: 1, value: num };

      if (/^[a-zA-Z]$/.test(size)) return { rank: 2, value: size.toUpperCase().charCodeAt(0) };

      return { rank: 3, value: size };
    }

    labels.sort((a, b) => {
      const aSize = getSize(a);
      const bSize = getSize(b);

      const aRank = getSizeRank(aSize);
      const bRank = getSizeRank(bSize);

      if (aRank.rank !== bRank.rank) {
        return aRank.rank - bRank.rank;
      } else {
        return aRank.value < bRank.value ? -1 : aRank.value > bRank.value ? 1 : 0;
      }
    });

    labels.forEach(label => grid.appendChild(label));
  }

  function sortRecommendationsGrids() {
    const grids = recommendations.querySelectorAll('.size-grid');
    grids.forEach(sortSizeGrid);
  }

  // Initial sort if already performed
  if (recommendations.getAttribute('data-recommendations-performed') === 'true') {
    sortRecommendationsGrids();
  }

  // Observe for recommendation changes
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-recommendations-performed' &&
        recommendations.getAttribute('data-recommendations-performed') === 'true'
      ) {
        sortRecommendationsGrids();
      }
    });
  });

  observer.observe(recommendations, {
    attributes: true,
    attributeFilter: ['data-recommendations-performed']
  });
});

/* store location menu
document.querySelectorAll('li[data-name*="Australia"]').forEach(li => {
  const overflowMenu = li.closest('.overflow-menu');
  if (!overflowMenu) return;

  let removeTimeout;

  li.addEventListener('mouseenter', () => {
    clearTimeout(removeTimeout); // Cancel pending removal
    overflowMenu.classList.add('hovered');
  });

  li.addEventListener('mouseleave', () => {
    removeTimeout = setTimeout(() => {
      overflowMenu.classList.remove('hovered');
    }, 300); // Delay in milliseconds (e.g., 300ms)
  });
});
*/

// search header clicked
document.addEventListener('DOMContentLoaded', () => {
  const searchAction = document.querySelector('.search-action');
  const closeButton = document.querySelector('.predictive-search__close-modal-button');
  const header = document.querySelector('header-component');

  if (!header) return;

  if (searchAction) {
    searchAction.addEventListener('click', () => {
      document.body.classList.add('search-open');

      // Remove attribute only if it exists
      if (header.getAttribute('transparent') === 'not-sticky') {
        header.removeAttribute('transparent');
      }
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      document.body.classList.remove('search-open');

      // Add attribute back
      header.setAttribute('transparent', 'not-sticky');
    });
  }
});

  function isMacSafari(){
    const ua = navigator.userAgent || "";
    const vendor = navigator.vendor || "";
    const platform = navigator.platform || (navigator.userAgentData && navigator.userAgentData.platform) || "";
    const isMac = /Mac|Macintosh|MacIntel|iMac/.test(platform);
    const isSafariUA = /Safari/.test(ua) && !/Chrome|Chromium|Edg|OPR|Firefox|Android/.test(ua);
    const isAppleVendor = /Apple/.test(vendor);
    return isMac && isSafariUA && isAppleVendor;
  }

  if (isMacSafari()) {
    // Wait until body is available before adding class
    if (document.body) {
      document.body.classList.add('mac-safari');
    } else {
      document.addEventListener('DOMContentLoaded', function(){
        document.body.classList.add('mac-safari');
      });
    }
  }

  function isAppleSafari(){
    const ua = navigator.userAgent || "";
    const vendor = navigator.vendor || "";
    const platform = navigator.platform || (navigator.userAgentData && navigator.userAgentData.platform) || "";
    
    const isMac = /Mac|Macintosh|MacIntel|iMac/.test(platform);
    const isIOS = /iPhone|iPad|iPod/.test(platform) || /iP(hone|ad|od)/.test(ua);
    
    const isSafariUA = /Safari/.test(ua) && !/Chrome|Chromium|Edg|OPR|Firefox|Android/.test(ua);
    const isAppleVendor = /Apple/.test(vendor);

    return (isMac || isIOS) && isSafariUA && isAppleVendor;
  }

  if (isAppleSafari()) {
    document.addEventListener('DOMContentLoaded', function(){
      document.body.classList.add('mac-safari'); // or rename if it's not just Mac
    });
  }


  // loookbook
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.open-look-btn');
    if (!btn || btn.disabled) return;

    if (btn.closest('[id^="explore-lookbook-"]')) return;

    const clickedContent = btn.closest('.collection-card__content');
    if (!clickedContent) return;

    const isOpen = clickedContent.classList.contains('open');

    // Close all others
    document.querySelectorAll('.collection-card__content.open').forEach(content => {
      if (content !== clickedContent) {
        content.classList.remove('open');
        content.style.maxHeight = "45px";

        const otherBtn = content.querySelector('.open-look-btn');
        if (otherBtn) otherBtn.classList.remove('active');
      }
    });

    // Toggle current one
    if (!isOpen) {
      // OPEN → measure real height
      clickedContent.classList.add('open');
      btn.classList.add('active');

      // Wait for class to apply so scrollHeight is accurate
      requestAnimationFrame(() => {
        const fullHeight = clickedContent.scrollHeight;
        clickedContent.style.maxHeight = fullHeight + "px";
      });
    } else {
      // CLOSE
      clickedContent.style.maxHeight = "45px";
      clickedContent.classList.remove('open');
      btn.classList.remove('active');
    }
  });

  // wishlist mutation
  const wishlistJsonPending = new Map();

  function buildWishlistOptionsWithValues(product) {
    if (!product?.options?.length || !product?.variants?.length) return [];

    return product.options.map((option, index) => {
      const optionName = typeof option === 'string' ? option : option?.name || '';
      const optionKey = `option${index + 1}`;
      const values = [];

      product.variants.forEach((variant) => {
        const value = variant[optionKey];
        if (value && !values.includes(value)) values.push(value);
      });

      const selectedVariant = product.variants.find((v) => v.id === product.selected_or_first_available_variant?.id)
        || product.variants.find((v) => v.available)
        || product.variants[0];
      const selectedValue = selectedVariant?.[optionKey] || values[0] || '';

      return {
        name: optionName,
        position: index + 1,
        selected_value: selectedValue,
        values,
      };
    });
  }

  function injectWishlistProductScripts(product, anchor) {
    if (!product?.id || document.getElementById(`ProductJson-${product.id}`)) return;

    const productScript = document.createElement('script');
    productScript.type = 'application/json';
    productScript.id = `ProductJson-${product.id}`;
    productScript.textContent = JSON.stringify(product);

    const optionScript = document.createElement('script');
    optionScript.type = 'application/json';
    optionScript.id = `OptionJson-${product.id}`;
    optionScript.textContent = JSON.stringify(buildWishlistOptionsWithValues(product));

    if (anchor) {
      anchor.insertAdjacentElement('afterend', productScript);
      productScript.insertAdjacentElement('afterend', optionScript);
    } else {
      document.body.appendChild(productScript);
      document.body.appendChild(optionScript);
    }
  }

  function ensureWishlistProductJson(btn) {
    const productId = btn?.dataset?.productId;
    if (!productId || document.getElementById(`ProductJson-${productId}`)) {
      return Promise.resolve();
    }

    if (wishlistJsonPending.has(productId)) {
      return wishlistJsonPending.get(productId);
    }

    const handle =
      btn.dataset.productHandle ||
      btn.closest('.product-card')?.dataset?.productHandle;

    if (!handle) {
      return Promise.resolve();
    }

    const promise = fetch(`/products/${handle}.js`)
      .then((res) => (res.ok ? res.json() : null))
      .then((product) => {
        if (!product) return;
        injectWishlistProductScripts(product, btn);
        document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
        window.cmAnalytics?.registerFromShopifyJSON?.();
      })
      .catch((err) => {
        console.warn('[Wishlist] Failed to load product JSON for', handle, err);
      })
      .finally(() => {
        wishlistJsonPending.delete(productId);
      });

    wishlistJsonPending.set(productId, promise);
    return promise;
  }

  function prefetchWishlistJsonFromEvent(event) {
    const btn = event.target.closest?.('.btn-wishlist[data-lazy-wishlist-json]');
    if (!btn) return;
    ensureWishlistProductJson(btn);
  }

  document.addEventListener('mouseenter', prefetchWishlistJsonFromEvent, true);
  document.addEventListener('focusin', prefetchWishlistJsonFromEvent, true);

  document.addEventListener('click', (event) => {
    const btn = event.target.closest?.('.btn-wishlist[data-lazy-wishlist-json]');
    if (!btn || document.getElementById(`ProductJson-${btn.dataset.productId}`)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    ensureWishlistProductJson(btn).then(() => {
      btn.click();
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    const recommendations = document.querySelector('.product-recommendations');
    if (!recommendations) return;

    const observer = new MutationObserver(function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-recommendations-performed' &&
          recommendations.getAttribute('data-recommendations-performed') === 'true'
        ) {
          document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
          //observer.disconnect(); // stop watching after it's fired once
          break;
        }
      }
    });

    observer.observe(recommendations, { attributes: true });
  });

  
  /* Watch for dynamic price updates - Wishlist page
  document.addEventListener('DOMContentLoaded', function () {
    function cleanPriceLabels() {
      document.querySelectorAll('.price-compare-at, .price').forEach(el => {
        el.textContent = el.textContent
          .replace('Price: ', '')
          .replace('Now: ', '');
      });
    }

    // Watch for changes inside the wrapper
    const wrapper = document.querySelector('.ucwl-osc-css');
    if (wrapper) {
      const observer = new MutationObserver(() => {
        cleanPriceLabels();
      });

      observer.observe(wrapper, { childList: true, subtree: true });

      // Run once on load too
      cleanPriceLabels();
    } 
  });*/


  // wishlist header count - Ailene 20-10-2025
  document.body.addEventListener("initTheWishlist", () => {
    const count = Number(theWishlist.countItemWishlist() || 0);
    const el = document.querySelector('.wishlist__launch-point .count-item');
    if (!el) return console.warn('Element with the specified class not found.');

    if (count === 0) {
      el.textContent = '';
      el.setAttribute('aria-hidden', 'true');
      el.classList.add('is-hidden');
    } else {
      el.removeAttribute('aria-hidden');
      el.classList.remove('is-hidden');
      el.textContent = count > 1 ? `(${count})` : '1';
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    const wishlistBodyNode = document.querySelector("body");

    wishlistBodyNode.addEventListener("wishlistAddToCartEvent", (e) => {
      // Dispatch Horizon's expected cart update event
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: null,
          sourceId: 'wishlist',
          data: {
            didError: false,
            source: 'wishlist',
            productId: e.detail?.productId || null,
            variantId: e.detail?.variantId || null,
            itemCount: e.detail?.quantity || 1
          }
        }
      }));

      // 🔽 Add this part right after dispatching the event
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        cartDrawer.showDialog(); // force open the Horizon cart drawer
      }
    });
  });



  // home page carousel > last image
  document.addEventListener('DOMContentLoaded', function () {
      const galleries = document.querySelectorAll('.section-resource-list .start_last_image .product-card');

      galleries.forEach((gallery) => {
          const slideshow = gallery.querySelector('slideshow-slides');
          const slides = gallery.querySelectorAll('slideshow-slide');
          if (!slideshow || slides.length === 0) return;

          const scrollToLastSlide = () => {
              const lastSlide = slides[slides.length - 1];
              if (!lastSlide.offsetLeft) {
                  // If offsetLeft is not ready, wait a frame
                  requestAnimationFrame(scrollToLastSlide);
                  return;
              }
              slideshow.scrollTo({ left: lastSlide.offsetLeft, behavior: 'auto' });
          };

          requestAnimationFrame(scrollToLastSlide);
      });
  });

// Wishlist cart
  const isWishlisted = (btn) => {
    const path = btn?.querySelector?.('.cart-wishlist svg path');
    if (!path) return false;

    const fill = path.getAttribute('fill');
    if (fill && fill.toLowerCase() !== 'none') return true;

    const comp = getComputedStyle(path).fill?.toLowerCase();
    return comp && comp !== 'none' && comp !== 'rgba(0,0,0,0)' && comp !== 'transparent';
  };

  const setLabel = (btn) => {
    const span = btn.querySelector('span:last-child');
    if (!span) return;
    span.textContent = isWishlisted(btn) ? 'Remove from Wishlist' : 'Add to Wishlist';
  };

  document.querySelectorAll('.cart_item_footer .cart-wishlist').forEach(setLabel);

// --- Observe cart item count changes to refresh wishlist labels ---
const cartCountEl = document.querySelector('[ref="cartItemCount"]');

if (cartCountEl) {
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'childList' || m.type === 'characterData') {
        // Wait a moment for DOM morph/render to finish
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Re-run label sync
            document
              .querySelectorAll('.cart_item_footer .cart-wishlist')
              .forEach(setLabel);

            // ✅ Trigger wishlist re-init logic after cart refresh
            document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
          });
        });
        break;
      }
    }
  });

  observer.observe(cartCountEl, {
    subtree: true,
    childList: true,
    characterData: true,
  });
}


  const wishlistObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes?.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.cart_item_footer .cart-wishlist')) setLabel(node);
        node.querySelectorAll?.('.cart_item_footer .cart-wishlist').forEach(setLabel);
      });

      if (m.type === 'attributes' && m.target.classList?.contains('cart-wishlist')) {
        if (m.attributeName === 'class' && m.target.classList.contains('has-variant')) {
          setLabel(m.target);
        }
        if (m.attributeName === 'fill') setLabel(m.target.closest('.cart_item_footer  .cart-wishlist'));
      }
    }
  });

  wishlistObserver.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'fill']
  });

  document.body.addEventListener('click', (event) => {
    const btn = event.target.closest('.cart_item_footer .cart-wishlist');
    if (!btn) return;

    const drawer = btn.closest('cart-drawer-component') || document.querySelector('cart-drawer-component');
    if (drawer?.close) {
      drawer.close();
    } else {
      const dialog = document.querySelector('.cart-drawer__dialog[open]');
      if (dialog?.open && typeof dialog.close === 'function') dialog.close();
      document.documentElement.removeAttribute('scroll-lock');
    }

    setTimeout(() => setLabel(btn), 2000); 
  });
 
// --- Inject .gift-wrapping from /cart into .cart-drawer__summary #giftwrapping
async function injectGiftWrapIntoDrawer() {
  const target = document.querySelector('.cart-drawer__summary #giftwrapping');
  if (!target) return;

  try {
    // Fetch the cart page HTML and parse it
    const res = await fetch('/cart', { credentials: 'same-origin' });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Find the source gift wrap block on the cart template
    const source =
      doc.querySelector('.template-cart .cart-page__more-blocks .gift-wrapping') ||
      doc.querySelector('.cart__footer .gift-wrapping') ||
      doc.querySelector('.gift-wrapping');

    if (!source) return;

    // Replace any prior injection to avoid duplicates
    target.innerHTML = '';

    // Inject cloned markup
    const clone = source.cloneNode(true);

    // Avoid duplicate IDs inside the drawer
    clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));

    target.appendChild(clone);

    // If your gift-wrap UI needs re-init, fire an init hook here
    document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
    document.body.dispatchEvent(new CustomEvent('initGiftWrap')); // optional if you have one
  } catch (e) {
    console.error('[GiftWrapInject] failed:', e);
  }
}

// --- Run when the drawer opens (watch the <dialog> [open] attr)
(function watchDrawerOpen() {
  const dialog = document.querySelector('.cart-drawer__dialog');
  if (!dialog) return;

  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === 'attributes' && m.attributeName === 'open' && dialog.hasAttribute('open')) {
        // Wait for drawer content to render, then inject
        requestAnimationFrame(() => requestAnimationFrame(injectGiftWrapIntoDrawer));
      }
    }
  });
  obs.observe(dialog, { attributes: true, attributeFilter: ['open'] });
})();

// --- Also re-inject after AJAX cart updates (works with your theme events)
const CART_UPDATE_EVT = (window.ThemeEvents && window.ThemeEvents.cartUpdate) || 'cart:update';
document.addEventListener(CART_UPDATE_EVT, () => {
  requestAnimationFrame(() => requestAnimationFrame(injectGiftWrapIntoDrawer));
}, { capture: true });

// --- Fallback: if the drawer summary re-renders for any reason, re-inject
const summary = document.querySelector('.cart-drawer__summary');
if (summary) {
  const shortObs = new MutationObserver(() => {
    // debounce in a micro way
    shortObs.disconnect();
    requestAnimationFrame(() => requestAnimationFrame(injectGiftWrapIntoDrawer));
    setTimeout(() => shortObs.observe(summary, { childList: true, subtree: true }), 300);
  });
  shortObs.observe(summary, { childList: true, subtree: true });
}


})();